export enum ProductChangeSource {
    NightlySync = 1,
    WebhookSync,
    ForceSync,
    ConfigurationChange,
    VersionChange,
    DbCreated
}